<section class="bg-white p-6">
  <h1
    class="text-xl font-bold mb-6 text-dc-navy"
    [class.border-b]="faqDropDownEnabled"
    [class.border-gray-300]="faqDropDownEnabled"
    [class.pb-3]="faqDropDownEnabled"
  >
    {{ "FAQ.TITLE" | translate }}
  </h1>

  <!-- filters -->
  @if (faqDropDownEnabled) {
    <div class="flex flex-wrap gap-4 mb-6">
      <app-option-field
        [control]="form.get('category')"
        [options]="[
          { value: 'all', label: 'FAQ.CAT.ALL' | translate },
          { value: 'general', label: 'FAQ.CAT.GENERAL' | translate },
          { value: 'accounts', label: 'FAQ.CAT.ACCOUNTS' | translate }
        ]"
        labelKey="label"
        valueKey="value"
        class="w-48"
      ></app-option-field>

      <div class="ms-auto w-full sm:w-64">
        <div class="flex items-center border border-gray-300 overflow-hidden">
          <input
            type="text"
            [placeholder]="'FAQ.SEARCH.PLH' | translate"
            class="flex-grow px-4 py-2 text-sm focus:outline-none"
            [formControl]="searchControl"
          />
          <button type="button" class="px-4 text-dc-navy">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- accordion list -->
  @for (cat of categories | slice : 1; track cat) {
    <!-- category heading -->
    @if (hasCat(cat.value)) {
      <h3
        class="text-lg font-bold py-3 border-t border-dc-navy text-dc-navy"
        >
        {{ cat.label | translate }}
      </h3>
    }
    @for (f of filtered; track f) {
      <div [hidden]="f.cat !== cat.value">
        <div
          class="w-full text-left py-4 border-t border-dc-navy flex items-center justify-between"
          (click)="toggle(f)"
          >
          <span class="text-dc-black font-bold text-base">
            {{ displayQuestion(f) }}
          </span>
          <span class="text-2xl leading-none text-dc-navy">
            <i [ngClass]="f.open ? 'fas fa-minus' : 'fas fa-plus'"></i>
          </span>
        </div>
        @if (f.open) {
          <div
            class="border-b border-dc-navy py-2 px-2 bg-gray-50 text-base text-dc-black"
            >
            {{ displayAnswer(f) }}
          </div>
        }
      </div>
    }
  }
</section>
